import { BaseModel } from "@blue-chip/core";
import SpecDetail from "./SpecDetail";

export default class SpecDetailRoomType extends BaseModel {
  static get belongsTo() {
    return [SpecDetail];
  }
}
